'use client';
/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/no-arbitrary-value */
import { Input } from '@material-tailwind/react';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { MaterialIcon } from '../../MaterialIcon';

export interface InputProps {
  placeholder?: string;
  onChange: (value: string) => void;
  onInput?: () => void;
  type: string;
  value: string;
  error?: boolean;
  height?: number;
  disabled?: boolean;
  iconSize?: number;
  className?: string;
  labelClassName?: string;
  containerClassName?: string;
  validateInput?: (value: string) => void;
  isBold?: boolean;
  backgroundColor?: string;
}

export const InputCarInsurance: React.FC<InputProps> = ({
  placeholder,
  type,
  onChange,
  onInput,
  disabled = false,
  value,
  error,
  containerClassName = '',
  labelClassName,
  validateInput,
  isBold = false,
  backgroundColor = '',
}) => {
  const [showValidationError, setShowValidationError] = useState(false);
  const fontWeight = isBold ? '!font-semibold' : '!font-medium';
  const bgColor = backgroundColor ? backgroundColor : '';
  const defaultClassName = `!py-[7px] !px-3 rounded-lg border-solid border !border-t-[#BDBDBD] border-[#BDBDBD] focus:border-solid focus:border-[1px] focus:!border-[#757575] focus:border-t-[#757575] placeholder:[#9E9E9E] placeholder:opacity-100 focus:shadow-form !text-[#212121] lg:text-xl md:text-lg !text-base ${fontWeight} ${bgColor}`;
  const errorStyles = `!py-[7px] !px-3 rounded-lg border-solid border !border-t-[#E57373] !border-[#E57373] !bg-[#FFEBEE] placeholder:opacity-100 text-[#212121] lg:text-xl md:text-lg !text-base focus:shadow-none focus:!border-[#E57373] focus:!border-t-[#E57373] ${fontWeight}`;

  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node) &&
        validateInput
      ) {
        validateInput(value);
      }
    };

    if (validateInput) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [value, validateInput]);

  useEffect(() => {
    if (value && validateInput) {
      setShowValidationError(true);
      validateInput(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={containerRef} className={`relative ${containerClassName}`}>
      <Input
        className={classNames('h-9 w-full', {
          [errorStyles]: error && showValidationError,
          [defaultClassName]: !error,
        })}
        placeholder={placeholder}
        value={value}
        type={type}
        disabled={disabled}
        ref={inputRef}
        onBlur={() => {
          validateInput?.(value);
          setShowValidationError(true);
        }}
        onInput={() => {
          onInput?.();
          setShowValidationError(false);
        }}
        icon={
          error === undefined ||
          (error === false && Boolean(value) === false) ||
          !showValidationError ? null : error === false && Boolean(value) ? (
            <MaterialIcon
              icon="check_circle"
              className="cursor-default text-[#33691E]"
            />
          ) : (
            <MaterialIcon
              icon="cancel"
              className="cursor-default text-[#B71C1C]"
            />
          )
        }
        labelProps={{ className: labelClassName || 'hidden' }}
        containerProps={{
          className: `!min-h-9 !h-9`,
        }}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};
